import { render, staticRenderFns } from "./DriverSetupSection.vue?vue&type=template&id=786897ea&"
import script from "./DriverSetupSection.vue?vue&type=script&lang=js&"
export * from "./DriverSetupSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports